export default function Start() {
    return (
        <h1>Start tab</h1>
    );
}